module.exports = __webpack_public_path__ + "static/media/inactive-link.8b7166a5.svg";